(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-cart-recs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('hg-cart-recs-section');
  if (!section) return;

  var listEl = document.getElementById('hg-cart-recs-section-list');
  var prev = section.querySelector('.hg-recs-prev');
  var next = section.querySelector('.hg-recs-next');

  function updateArrows() {
    if (!prev || !next || !listEl) return;
    prev.disabled = listEl.scrollLeft <= 0;
    next.disabled = listEl.scrollLeft + listEl.clientWidth >= listEl.scrollWidth - 1;
  }

  if (listEl) {
    updateArrows();
    listEl.addEventListener('scroll', updateArrows);
  }
  if (prev) prev.onclick = function () { listEl.scrollBy({ left: -300, behavior: 'smooth' }); };
  if (next) next.onclick = function () { listEl.scrollBy({ left: 300, behavior: 'smooth' }); };

  /* Add to cart buttons (single-variant products) */
  if (listEl) {
    listEl.querySelectorAll('button.hg-rec-card__add[data-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var fd = new FormData();
        fd.append('id', btn.dataset.variant);
        fd.append('quantity', '1');
        fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function () {
            /* open hg cart drawer if present, otherwise reload */
            if (typeof window.hgCartOpen === 'function') {
              window.hgCartOpen();
            } else {
              window.location.reload();
            }
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    var slider = document.getElementById('collectionCategoriesSlider');
    var btnLeft = document.getElementById('collectionSliderBtnLeft');
    var btnRight = document.getElementById('collectionSliderBtnRight');
    if (!slider) return;

    function updateButtons() {
      var atStart = slider.scrollLeft <= 0;
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
      if (btnLeft) btnLeft.disabled = atStart;
      if (btnRight) btnRight.disabled = atEnd;
    }

    if (btnLeft) {
      btnLeft.addEventListener('click', function () {
        slider.scrollBy({ left: -300, behavior: 'smooth' });
        setTimeout(updateButtons, 320);
      });
    }

    if (btnRight) {
      btnRight.addEventListener('click', function () {
        slider.scrollBy({ left: 300, behavior: 'smooth' });
        setTimeout(updateButtons, 320);
      });
    }

    slider.addEventListener('scroll', updateButtons);
    updateButtons();

    var section = slider.closest('.categoriesSection');
    var imgs = Array.prototype.slice.call(slider.querySelectorAll('img'));
    if (section && imgs.length > 0) {
      var pending = imgs.length;
      function onSettle() {
        pending--;
        if (pending > 0) return;
        var visible = slider.querySelectorAll('.categoryCard:not([style*="none"])').length;
        if (visible === 0) section.style.display = 'none';
      }
      imgs.forEach(function(img) {
        if (img.complete) { onSettle(); }
        else { img.addEventListener('load', onSettle); img.addEventListener('error', onSettle); }
      });
    } else if (section && imgs.length === 0) {
      section.style.display = 'none';
    }
  })();

  document.querySelectorAll('.heroMetaContent').forEach(function (box) {
    var btn = box.querySelector('.heroReadMoreBtn');
    if (!btn || box.querySelectorAll('ul li').length <= 2) return;
    box.setAttribute('data-hg-collapsible', '');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-expanded');
      btn.textContent = open ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  window.toggleBrandMore = function(btn) {
    var row = btn.closest('.brandFeatureDescRow');
    if (!row) return;
    var txt = row.querySelector('.brandFeatureDescText');
    if (!txt) return;
    var expanded = txt.classList.toggle('brandExpanded');
    btn.textContent = expanded ? 'Read less' : 'Read more';
  };

  (function () {
    var brandImgs = document.querySelectorAll('.brandFeatureImage img');
    brandImgs.forEach(function (img) {
      if (img.complete) {
        img.style.transition = 'none';
        img.classList.add('brand-img-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('brand-img-loaded'); });
      }
    });
    var heroImgs = document.querySelectorAll('.heroImage img');
    heroImgs.forEach(function (img) {
      if (img.complete) {
        img.style.transition = 'none';
        img.classList.add('brand-img-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('brand-img-loaded'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-brands"]) return;
  try {
    
  (function() {
    var filterBtns = document.querySelectorAll('.filterBtn');
    var cards = document.querySelectorAll('.brandCard');
    var noResults = document.getElementById('brandsNoResults');
    var filterText = document.getElementById('brandsFilterText');
    var activeFilter = null;

    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var letter = btn.getAttribute('data-filter');

        if (activeFilter === letter) {
          activeFilter = null;
          filterBtns.forEach(function(b) { b.classList.remove('active'); });
          cards.forEach(function(c) { c.classList.remove('is-hidden'); });
          noResults.classList.remove('is-visible');
          return;
        }

        activeFilter = letter;
        filterBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var visible = 0;
        cards.forEach(function(card) {
          var name = card.getAttribute('data-brand-name') || '';
          var show = letter === '#' ? /^[0-9]/.test(name.charAt(0)) : name.charAt(0) === letter;
          card.classList.toggle('is-hidden', !show);
          if (show) visible++;
        });

        noResults.classList.toggle('is-visible', visible === 0);
        if (filterText) filterText.textContent = letter;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
